module.exports = __webpack_public_path__ + "static/media/step_detail_career_khai_khoang_mobile.5f8889b3.png";